import { gql } from '@apollo/client/core'
import { useMutation } from '@vue/apollo-composable'
import { IResetPasswordResponse } from '@types'

const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
    resetPassword(resetPasswordInput: $resetPasswordInput) {
      type
      payload {
        ... on StringResponse {
          message
        }
      }
    }
  }
`

/**
 * Hook para a mutação de redefinição de senha.
 * @returns A mutação de redefinição de senha.
 */
export const useResetPasswordMutation = () => {
  const mutation = useMutation<IResetPasswordResponse>(RESET_PASSWORD_MUTATION)
  return mutation
}
